import { Button, FormControl, FormHelperText, FormLabel, Input } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '../../providers/AuthProvider';
import { ProjectContext } from '../../providers/ProjectProvider';

export default function ProjectCreateForm() {
  const { updateUser, currentUser } = useAuth();
  const { updateProjects, setProjects, projects } = useContext(ProjectContext);
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (currentUser) {
      setName(`${currentUser.name}のプロジェクト`);
    }
  }, [currentUser]);

  const handleClick = () => {
    setIsLoading(true);

    axios
      .post(
        `${process.env.NEXT_PUBLIC_API_HOST}/projects`,
        {
          name: name,
        },
        {
          withCredentials: true,
        }
      )
      .then(async () => {
        // プロジェクトを作成したらツール一覧へ遷移する
        await Promise.all([updateUser(), updateProjects()]).then(async () => {
          // TODO ツール一覧へ遷移したときに、プロジェクトが0件のアラートを避けるための応急処置。ほんとはよくない。
          setTimeout(() => {
            router.push('/tools');
          }, 1000);
        });
      })
      .catch((error) => {
        if (error.response.status !== 400) {
          router.push('/dashboard');
        }
        setIsLoading(false);
      });
  };
  return (
    <>
      <FormControl>
        <FormLabel htmlFor="name">プロジェクト名</FormLabel>
        <Input id="name" type="name" onChange={(e) => setName(e.target.value)} value={name} maxLength={100} autoFocus />
        <FormHelperText>後からいつでも変更できます。サービス名や会社名、個人名などがおすすめです。</FormHelperText>
      </FormControl>

      <Button
        bg={'#3F5FF6'}
        _hover={{ bg: '#3F5FF6', opacity: 0.8, _disabled: { opacity: 0.4 } }}
        color={'white'}
        onClick={handleClick}
        mt={10}
        isLoading={isLoading}
        disabled={name.length === 0 || isLoading}
      >
        作成する
      </Button>
    </>
  );
}
